import React, { useEffect, useState } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { getAdminInfo } from "../api/admin";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // Add a loading state

  useEffect(() => {
    const adminData = localStorage.getItem("token");
    const token = adminData ? JSON.parse(adminData) : null;
    if (!token) {
      setLoading(false); // Mark loading as complete if no tokenset
      setIsAuthenticated(false);
      return;
    }
    getAdminInfo(token).then((data) => {
      if (token && data?.role && token !== null && data?.role === "admin") {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }

      setLoading(false); // Mark loading as complete
    });
  }, []);

  if (loading) {
    // Show a loading indicator while checking authentication
    return <div>Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default PrivateRoute;
